module.exports = __webpack_public_path__ + "10_hige_black.eddc0fb3.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer3/10_hige_black.png
// module id = eFFp
// module chunks = 0